module.exports = __webpack_public_path__ + "static/media/perfil.8e1bce10.svg";